// extracted by mini-css-extract-plugin
module.exports = {"sendButton":"styles_sendButton__C_cAn"};